import { apiClient } from '../utils/api-client'
import type { Goal } from '../types/goal'

interface GoalPayload {
  target_date: string
  body: string
}

interface GoalResponse {
  data: {
    id: string
    type: string
    attributes: Goal
  }
}

interface GoalsResponse {
  data: Array<{
    id: string
    type: string
    attributes: Goal
  }>
}

class GoalsService {
  async list(from?: string, to?: string): Promise<Goal[]> {
    const params = new URLSearchParams()
    if (from) params.set('from', from)
    if (to) params.set('to', to)
    const query = params.toString() ? `?${params}` : ''
    const response = await apiClient.get(`/api/goals${query}`, { requireAuth: true })
    const json: GoalsResponse = await response.json()
    return json.data.map((d) => ({ ...d.attributes, id: d.id }))
  }

  async create(payload: GoalPayload): Promise<Goal> {
    const response = await apiClient.post('/api/goals', {
      data: { attributes: payload },
    }, { requireAuth: true })
    const json: GoalResponse = await response.json()
    return { ...json.data.attributes, id: json.data.id }
  }

  async update(id: string, payload: Partial<GoalPayload>): Promise<Goal> {
    const response = await apiClient.patch(`/api/goals/${id}`, {
      data: { attributes: payload },
    }, { requireAuth: true })
    const json: GoalResponse = await response.json()
    return { ...json.data.attributes, id: json.data.id }
  }

  async destroy(id: string): Promise<void> {
    await apiClient.delete(`/api/goals/${id}`, { requireAuth: true })
  }
}

export const goalsService = new GoalsService()
